export const SET_ELECTRICITY_DATA = 'SET_ELECTRICITY_DATA';

export function setElectricityData(data) {
    return {
        type: SET_ELECTRICITY_DATA,
        payload: data
    };
}
